import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ApiService } from './api.service';

import { OnBaseDocumentGroup, OnBaseDocumentType, OnBaseKeyword, OnBaseMappedKeyword } from '../models/onBaseIntegrationAndMapping.model';


@Injectable()
export class OnBaseIntegrationAndMappingService {
    public BaseUrl = '/api/onBaseIntegrationAndMapping';

    constructor(
        public http: HttpClient,
        public apiService: ApiService
    ) { }

    getAllDocumentGroups(): Observable<Array<OnBaseDocumentGroup>> {
        const url = `${this.BaseUrl}/documentGroups/all`;
        return this.http.get<OnBaseDocumentGroup[]>(url);
    }

    getDocumentTypesByDocumentGroup(documentGroupName: string): Observable<OnBaseDocumentType[]> {
        const url = `${this.BaseUrl}/documentTypes/getByDocumentGroup`;
        return this.http.get<OnBaseDocumentType[]>(`${url}/${documentGroupName}`);
    }

    getAllDocumentTypes(): Observable<Array<OnBaseDocumentType>> {
        const url = `${this.BaseUrl}/documentTypes/all`;
        return this.http.get<OnBaseDocumentType[]>(url);
    }

    GetAllKeywords(): Observable<Array<OnBaseKeyword>> {
        const url = `${this.BaseUrl}/keywords/all`;
        return this.http.get<OnBaseKeyword[]>(url);
    }

    GetKeywordsByDocumentGroup(documentGroupName: string): Observable<Array<OnBaseMappedKeyword>> {
        const url = `${this.BaseUrl}/keywords/getByDocumentGroup`;
        return this.http.get<OnBaseMappedKeyword[]>(`${url}/${documentGroupName}`);
    }

    GetKeywordsByDocumentType(documentTypeName: string): Observable<Array<OnBaseMappedKeyword>> {
        const url = `${this.BaseUrl}/keywords/getByDocumentType`;
        return this.http.get<OnBaseMappedKeyword[]>(`${url}/${documentTypeName}`);
    }

    importOnBaseMappings(): Observable<boolean> {
        const url = `${this.BaseUrl}/importall`;
        return this.http.get<boolean>(url);
    }

    runGroupMapping(group: OnBaseDocumentGroup): Observable<string> {
        return this.http.post<string>(`${this.BaseUrl}/synchronize-group`, group);
    }

    deleteDiscontinuedGroups(existingGroups: OnBaseDocumentGroup[]): Observable<number> {
        return this.http.post<number>(`${this.BaseUrl}/delete-discontinued-groups`, existingGroups);
    }
}
